module.exports = __webpack_public_path__ + "img/Anya_O_3.8eef05ac.jpg";